// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"u_-z","inlineTitle":"v_-z","microsoftAdsWrapper":"w_-z","marketplaceRecosWrapper":"x_-z","brandShopTheLookWrapper":"y_-z"};